const data = [
  {
    id: 1,
    title: "How many days do I have to return the product?",
    info: "You can return any product up to 14 days after buying, provided it is in immaculate condition",
  },
  {
    id: 2,
    title: "Do I need to provide my phone number when creating account?",
    info: "No, providing your phone number when registering your account is not required, however we inform our customers about our greatest deals via sms. You can remove your phone number at any time.",
  },
  {
    id: 3,
    title: "Why is Gamora?",
    info: "We don't know where, who and why is Gamora. Sorry :(",
  },
];
export default data;
